import axios from 'axios';

export default {
  // Sales endpoints
  index: (params = {}, config = {}) => axios.get('sales', { params, ...config }),
  store: (data = {}) => axios.post('sales', data),
  update: (saleId, data = {}, config = {}) => axios.put(`sales/${saleId}`, data, config),
  updateStatus: (saleId, data = {}, config = {}) => axios.put(`sales/${saleId}/status`, data, config),
  delete: (saleId, config = {}) => axios.delete(`sales/${saleId}`, config),
  flatRates: (data = {}) => axios.post('sales/igualas', data),
  metrics: (params = {}, config = {}) => axios.get('sales/metrics', { params, ...config }),
  show: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}`, { params, ...config }),
  detailMetrics: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}/metrics`, { params, ...config }),
  paymentFlow: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}/payment-flow`, { params, ...config }),
  progress: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}/progress`, { params, ...config }),
  activity: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}/activity`, { params, ...config }),
  documentsIndex: (saleId, params = {}, config = {}) => axios.get(`sales/${saleId}/documents`, { params, ...config }),
  documentsStore: (saleId, payload = {}, config = {}) => axios.post(`sales/${saleId}/documents`, payload, config),
  documentsUpdate: (saleId, documentId, payload = {}, config = {}) => axios.put(`sales/${saleId}/documents/${documentId}`, payload, config),
  documentsDelete: (saleId, documentId, config = {}) => axios.delete(`sales/${saleId}/documents/${documentId}`, config),
  documentsDownloadAll: (saleId, params = {}, config = {}) => axios.get(
    `sales/${saleId}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),

  // Sales support endpoints
  saleCode: (params = {}, config = {}) => axios.get('consecutives/sale-code', { params, ...config }),

  // Catalog endpoints
  statuses: (params = {}, config = {}) => axios.get('sale-statuses', { params, ...config }),
};
